import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EffectsModule } from "@ngrx/effects";
import { FaqEffects } from "./faq.effects";

@NgModule({
  declarations: [],
  imports: [CommonModule, EffectsModule.forFeature([FaqEffects])],
})
export class FaqModule {}
